import { IncludeType } from '../../../common';
import { Product } from '../../models/product';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getProductsBySkus = async (
  skus: string[],
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<Product[]> => {
  const url = `/product/filter?skus=${skus.join('|')}&include=${encodeURIComponent(includeType)}&marketLocale=${locale}`;
  const response = await productCatalogueHttp.get<Product[]>(url);
  return response.data;
};
